import React, {useCallback} from 'react';
import {Button} from '../button/Button';
import {Layout} from '../layout';
import {ButtonGroupProps} from './types';

export const ButtonGroup: React.FC<ButtonGroupProps> = ({
  items,
  badges = [],
  selectedIndex,
  hasBorders = true,
  round = true,
  size,
  onSelectedIndexChange,
}) => {
  const handleButtonClicked = useCallback(
    (index: number) => onSelectedIndexChange && onSelectedIndexChange(index),
    [onSelectedIndexChange],
  );
  return (
    <Layout
      borderStyle={hasBorders ? 'solid' : undefined}
      borderColor={hasBorders ? 'border_mono_15' : undefined}
      borderWidth={hasBorders ? '1' : undefined}
      borderRadius={round ? '4' : undefined}
      overflow={hasBorders ? 'hidden' : undefined}>
      {items.map((item, index) => (
        <Layout
          key={index}
          borderRadius={!hasBorders && round ? '4' : undefined}
          backgroundColor={
            selectedIndex === index ? 'background_mono_tertiary' : undefined
          }>
          <Button
            kind={'Clear'}
            title={item}
            state={selectedIndex === index ? 'Excited' : 'Default'}
            badge={badges[index] ? badges[index].toString() : undefined}
            size={size}
            onPress={() => handleButtonClicked(index)}
          />
        </Layout>
      ))}
    </Layout>
  );
};
